/**
 * Recommended number of classes for each activity by track
 * 
 * This file allows you to configure the recommended number of classes
 * for each activity in milestones. The structure is:
 * 
 * {
 *   track_name: {
 *     "activity_name": number_of_classes
 *   }
 * }
 * 
 * Update the numbers below to change the recommended classes displayed
 * in the project details page next to each activity.
 */

export const RECOMMENDED_CLASSES = {
  // Product Track Activities
  product: {
    "Brainstorm + Introduction to mentor and research area": 2,
    "Scope Finalisation": 1,
    "Learning": 3,
    "Workflow (BOM, connections, software architecture, content architecture)": 2,
    "Building": 4,
    "Testing (might need to re-build)": 2,
    "Deployment": 1,
    "Data collection & Data analysis (OPTIONAL)": 2,
    "Competition submission": 1
  },

  // Research Track Activities
  research: {
    "Brainstorm + Introduction to mentor and research area": 2,
    "Lit review": 3,
    "Introduction": 2,
    "Methodology (hypothesis formulation)": 2,
    "Data collection": 3,
    "Data analysis": 3,
    "Results": 2,
    "Discussion & Abstract": 2,
    "Final Manuscript": 2,
    "Journal submission": 1,
    "Competition submission": 1
  },

  // Product Research Track Activities
  product_research: {
    "Brainstorm + Introduction to mentor and research area": 2,
    "Lit review": 3,
    "Introduction": 2,
    "Systems design (Optional)": 2,
    "Methodology": 2,
    "Data collection": 3,
    "Data analysis": 3,
    "Results": 2,
    "Discussion & Abstract": 2,
    "Final Manuscript": 2,
    "Journal submission": 1,
    "Competition submission": 1
  }
};

/**
 * Get recommended number of classes for an activity in a specific track
 * @param {string} track - The project track ('product', 'research', 'product_research')
 * @param {string} activity - The activity name
 * @returns {number|null} - Recommended number of classes, or null if not found
 */
export const getRecommendedClasses = (track, activity) => {
  if (!RECOMMENDED_CLASSES[track]) {
    return null;
  }
  
  // Try exact match first
  if (RECOMMENDED_CLASSES[track][activity] !== undefined) {
    return RECOMMENDED_CLASSES[track][activity];
  }
  
  // Try partial match (in case activity name has slight variations)
  const activityLower = activity.toLowerCase();
  for (const [key, value] of Object.entries(RECOMMENDED_CLASSES[track])) {
    if (key.toLowerCase().includes(activityLower) || activityLower.includes(key.toLowerCase())) {
      return value;
    }
  }
  
  return null;
};

export default RECOMMENDED_CLASSES;

